import { useState } from 'react';
import { salvarPersonaPortal } from '../../lib/portal';
import { SECOES_PERFIL_MARCA } from '../../lib/perfilMarcaPerguntas';

function contarRespondidas(secao, respostas) {
  return secao.campos.filter(c => {
    const v = respostas[c.key];
    return Array.isArray(v) ? v.length > 0 : Boolean(v);
  }).length;
}

function Campo({ campo, valor, onChange }) {
  if (campo.tipo === 'chips') {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {campo.opcoes.map(op => {
          const ativo = valor === op;
          return (
            <button key={op} onClick={() => onChange(ativo ? '' : op)}
              style={{ padding: '7px 13px', borderRadius: 20, border: `1.5px solid ${ativo ? 'var(--purple)' : 'var(--border)'}`, background: ativo ? 'var(--purple)' : 'transparent', color: ativo ? 'white' : 'var(--text-secondary)', cursor: 'pointer', fontSize: 12, fontWeight: ativo ? 700 : 400 }}>
              {op}
            </button>
          );
        })}
      </div>
    );
  }
  if (campo.tipo === 'chips-multi') {
    const selecionados = Array.isArray(valor) ? valor : [];
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {campo.opcoes.map(op => {
          const ativo = selecionados.includes(op);
          return (
            <button key={op} onClick={() => onChange(ativo ? selecionados.filter(v => v !== op) : [...selecionados, op])}
              style={{ padding: '7px 13px', borderRadius: 20, border: `1.5px solid ${ativo ? 'var(--purple)' : 'var(--border)'}`, background: ativo ? 'var(--purple)' : 'transparent', color: ativo ? 'white' : 'var(--text-secondary)', cursor: 'pointer', fontSize: 12, fontWeight: ativo ? 700 : 400 }}>
              {op}
            </button>
          );
        })}
      </div>
    );
  }
  if (campo.tipo === 'textarea') {
    return (
      <textarea value={valor || ''} onChange={e => onChange(e.target.value)} rows={3}
        style={{ width: '100%', padding: '9px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit' }} />
    );
  }
  return (
    <input value={valor || ''} onChange={e => onChange(e.target.value)}
      style={{ width: '100%', padding: '9px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, boxSizing: 'border-box' }} />
  );
}

export default function PortalPerfilMarca({ token, persona }) {
  const [respostas, setRespostas] = useState(persona?.respostas || {});
  const [observacoes, setObservacoes] = useState(persona?.observacoes || '');
  const [secaoAberta, setSecaoAberta] = useState(0);
  const [salvando, setSalvando] = useState(false);
  const [salvo, setSalvo] = useState(false);

  function atualizarCampo(key, valor) {
    setRespostas(r => ({ ...r, [key]: valor }));
    setSalvo(false);
  }

  async function salvar() {
    setSalvando(true);
    try {
      await salvarPersonaPortal(token, respostas, observacoes);
      setSalvo(true);
    } catch (e) {
      alert('Não consegui salvar: ' + e.message);
    }
    setSalvando(false);
  }

  const totalCampos = SECOES_PERFIL_MARCA.reduce((s, sec) => s + sec.campos.length, 0);
  const totalRespondidos = SECOES_PERFIL_MARCA.reduce((s, sec) => s + contarRespondidas(sec, respostas), 0);

  return (
    <div>
      <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 10, lineHeight: 1.6 }}>
        Quanto mais completo esse formulário, mais a cara de vocês fica o conteúdo — tom, jeito de falar,
        quem é o público ideal, o que evitar. Pode salvar a qualquer momento e voltar depois pra completar.
      </div>
      <div style={{ fontSize: 12, color: 'var(--purple-rich)', fontWeight: 600, marginBottom: 18 }}>
        {totalRespondidos} de {totalCampos} perguntas respondidas
      </div>

      {SECOES_PERFIL_MARCA.map((secao, i) => {
        const aberta = secaoAberta === i;
        const respondidas = contarRespondidas(secao, respostas);
        return (
          <div key={secao.titulo} className="card" style={{ marginBottom: 10, overflow: 'hidden' }}>
            <button onClick={() => setSecaoAberta(aberta ? -1 : i)}
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', background: 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>
              <span style={{ fontWeight: 700, fontSize: 14, color: 'var(--text-primary)' }}>{secao.titulo}</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 11, color: respondidas === secao.campos.length ? '#16a34a' : 'var(--gray-400)', fontWeight: 600 }}>
                  {respondidas === secao.campos.length ? '✓ completo' : `${respondidas}/${secao.campos.length}`}
                </span>
                <span style={{ color: 'var(--purple)', fontSize: 13 }}>{aberta ? '▲' : '▼'}</span>
              </span>
            </button>
            {aberta && (
              <div style={{ padding: '0 18px 18px' }}>
                {secao.campos.map(campo => (
                  <div key={campo.key} style={{ marginBottom: 14 }}>
                    <label style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 6 }}>{campo.label}</label>
                    <Campo campo={campo} valor={respostas[campo.key]} onChange={v => atualizarCampo(campo.key, v)} />
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}

      <div className="card" style={{ padding: 16, marginTop: 14, marginBottom: 16 }}>
        <div style={{ fontWeight: 700, fontSize: 13.5, color: 'var(--text-primary)', marginBottom: 10 }}>Alguma observação extra? (opcional)</div>
        <textarea value={observacoes} onChange={e => { setObservacoes(e.target.value); setSalvo(false); }} rows={3}
          placeholder="Qualquer coisa que não coube nas perguntas acima..."
          style={{ width: '100%', padding: '9px 12px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', resize: 'vertical' }} />
      </div>

      <button onClick={salvar} disabled={salvando}
        style={{ background: 'linear-gradient(135deg, var(--purple), var(--purple-rich))', color: 'white', border: 'none', padding: '11px 26px', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontSize: 13.5 }}>
        {salvando ? 'Salvando...' : salvo ? '✓ Salvo' : 'Salvar perfil'}
      </button>
    </div>
  );
}
